import React from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

// Re-keys on every route change so the entrance animation replays on navigation —
// and runs once on first load too.
const PageTransition = ({ children }) => {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-enter">
      {children}
    </div>
  );
};

export default PageTransition;
